<template>
  <div class="biao-xing-section">
    <a-card title="表型数据" :headStyle="headStyle" class="margin-top-20">
      <template #extra>
        <a-button
          type="primary"
          size="small"
          @click="showModal('add')"
        >
          添加表型记录
        </a-button>
      </template>
      
      <a-tabs v-model="activeKey" @change="handleTabChange">
        <a-tab-pane key="chart" tab="图表">
          <div v-if="chartLoading" class="loading-container">
            <a-spin tip="加载中..." />
          </div>
          <a-empty v-else-if="!chartData" description="暂无数据" />
          <chart-line :height="350" :data="chartData" v-else></chart-line>
        </a-tab-pane>
        
        <a-tab-pane key="table" tab="表格">
          <div v-if="tableLoading" class="loading-container">
            <a-spin tip="加载中..." />
          </div>
          <a-empty v-else-if="tableData.length === 0" description="暂无数据" />
          <a-table 
            v-else
            :columns="columns" 
            :dataSource="tableData"
            :pagination="false"
            :rowKey="record => record.id"
          > 
            <template slot="height" slot-scope="text">
              {{ text || '-' }}
            </template>
            <template slot="shen_chang" slot-scope="text">
              {{ text || '-' }}
            </template>
            <template slot="weight" slot-scope="text">
              {{ text || '-' }}
            </template>
            <template slot="width" slot-scope="text">
              {{ text || '-' }}
            </template>
            <template slot="chest_girth" slot-scope="text">
              {{ text || '-' }}
            </template>
            <template slot="recorded_at" slot-scope="text">
              {{ text || '-' }}
            </template>
            <template slot="operations" slot-scope="text, record">
              <a-dropdown>
                <a-menu slot="overlay" @click="({ key }) => handleMenuClick(key, record)">
                  <a-menu-item key="edit">
                    <a-icon type="edit" />
                    编辑
                  </a-menu-item>
                  <a-menu-item key="delete">
                    <a-icon type="delete" />
                    删除
                  </a-menu-item>
                </a-menu>
                <a-button size="small">
                  操作 <a-icon type="down" />
                </a-button>
              </a-dropdown>
            </template>
          </a-table>
        </a-tab-pane>
      </a-tabs>
    </a-card>

    <a-modal
      :title="editMode === 'add' ? '添加表型记录' : '编辑表型记录'"
      :visible="isModalVisible"
      @ok="handleOk"
      @cancel="handleCancel"
      :confirmLoading="submitLoading"
    >
      <a-form-model
        ref="formRef"
        :model="form"
        :rules="rules"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 16 }"
      >
        <a-form-model-item label="身高" prop="height">
          <a-input 
            v-model="form.height" 
            placeholder="请输入身高"
            suffix="cm"
          />
        </a-form-model-item>
        
        <a-form-model-item label="身长" prop="shen_chang">
          <a-input 
            v-model="form.shen_chang" 
            placeholder="请输入身长"
            suffix="cm"
          />
        </a-form-model-item>
        
        <a-form-model-item label="体重" prop="weight">
          <a-input 
            v-model="form.weight" 
            placeholder="请输入体重"
            suffix="kg"
          />
        </a-form-model-item>
        
        <a-form-model-item label="体宽" prop="width">
          <a-input 
            v-model="form.width" 
            placeholder="请输入体宽"
            suffix="cm"
          />
        </a-form-model-item>
        
        <a-form-model-item label="胸围" prop="chest_girth">
          <a-input 
            v-model="form.chest_girth" 
            placeholder="请输入胸围"
            suffix="cm"
          />
        </a-form-model-item>
        
        <a-form-model-item label="记录日期" prop="recorded_at">
          <a-date-picker 
            v-model="form.recorded_at" 
            style="width: 100%"
            placeholder="请选择记录日期"
            valueFormat="YYYY-MM-DD"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import ChartLine from "@/components/Charts/ChartLine.vue";

export default {
  name: "BiaoXingSection",
  components: {
    ChartLine,
  },
  props: {
    itemId: {
      type: Number,
      required: true,
    },
    farmId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      activeKey: 'chart',
      isModalVisible: false,
      submitLoading: false,
      chartLoading: false,
      tableLoading: false,
      editMode: 'add',
      form: {
        farm_id: '',
        height: '',
        shen_chang: '',
        weight: '',
        width: '',
        chest_girth: '',
        recorded_at: '',
        breed_item_id: '',
      },
      tableData: [],
      chartData: null,
      columns: [
        {
          title: '身高(cm)',
          dataIndex: 'height',
          key: 'height',
          scopedSlots: { customRender: 'height' },
          width: '15%',
        },
        {
          title: '身长(cm)',
          dataIndex: 'shen_chang',
          key: 'shen_chang',
          scopedSlots: { customRender: 'shen_chang' },
          width: '15%',
        },
        {
          title: '体重(kg)',
          dataIndex: 'weight',
          key: 'weight',
          scopedSlots: { customRender: 'weight' },
          width: '15%',
        },
        {
          title: '体宽(cm)',
          dataIndex: 'width',
          key: 'width',
          scopedSlots: { customRender: 'width' },
          width: '15%',
        },
        {
          title: '胸围(cm)',
          dataIndex: 'chest_girth',
          key: 'chest_girth',
          scopedSlots: { customRender: 'chest_girth' },
          width: '15%',
        },
        {
          title: '记录日期',
          dataIndex: 'recorded_at',
          key: 'recorded_at',
          scopedSlots: { customRender: 'recorded_at' },
          width: '20%',
        },
        {
          title: '操作',
          key: 'operations',
          scopedSlots: { customRender: 'operations' },
          width: '15%',
        },
      ],
      headStyle: {
        backgroundColor: '#2563EB',
        color: '#efefef',
        'border-radius': '10px 10px 0px 0px',
        'font-weight': 'bold',
      },
      rules: {
        height: [
          {
            required: true,
            message: '请输入身高',
            trigger: 'blur',
          },
          {
            pattern: /^\d+(\.\d+)?$/,
            message: '请输入有效的数字',
            trigger: 'blur',
          },
        ],
        shen_chang: [
          {
            required: true,
            message: '请输入身长',
            trigger: 'blur',
          },
          {
            pattern: /^\d+(\.\d+)?$/,
            message: '请输入有效的数字',
            trigger: 'blur',
          },
        ],
        weight: [
          {
            required: true,
            message: '请输入体重',
            trigger: 'blur',
          },
          {
            pattern: /^\d+(\.\d+)?$/,
            message: '请输入有效的数字',
            trigger: 'blur',
          },
        ],
        width: [
          {
            pattern: /^\d+(\.\d+)?$/,
            message: '请输入有效的数字',
            trigger: 'blur',
          },
        ],
        chest_girth: [
          {
            pattern: /^\d+(\.\d+)?$/,
            message: '请输入有效的数字',
            trigger: 'blur',
          },
        ],
        recorded_at: [
          {
            required: true,
            message: '请选择记录日期',
            trigger: 'change',
          },
        ],
      },
    };
  },
  mounted() {
    this.form.breed_item_id = this.itemId;
    this.form.farm_id = this.farmId;
    this.loadData();
  },
  methods: {
    // 加载数据
    async loadData() {
      await Promise.all([
        this.loadChartData(),
        this.loadTableData(),
      ]);
    },
    
    // 加载图表数据
    async loadChartData() {
      this.chartLoading = true;
      try {
        const res = await this.$api.getBiaoXingChartData({
          breed_item_id: this.itemId,
          farm_id: this.farmId,
        });
        if (res.code === 200 && res.data) {
          const { labels = [], datasets = [] } = res.data;
          if (labels.length > 0 && datasets.length > 0) {
            // ChartLine expects [{date, value}]; use the first dataset (weight) as primary
            const primaryData = datasets[0]?.data || [];
            this.chartData = labels.map((date, i) => ({
              date,
              value: primaryData[i] ?? 0,
            }));
          } else {
            this.chartData = null;
          }
        } else {
          this.chartData = null;
        }
      } catch (error) {
        console.error('加载图表数据失败:', error);
        this.$message.error('加载图表数据失败');
        this.chartData = null;
      } finally {
        this.chartLoading = false;
      }
    },
    
    // 加载表格数据
    async loadTableData() {
      this.tableLoading = true;
      try {
        const res = await this.$api.get_biao_xing_records({
          breed_item_id: this.itemId,
          farm_id: this.farmId,
          page_no: 1,
          page_size: 100,
        });
        this.tableData = res.data || [];
      } catch (error) {
        console.error('加载表格数据失败:', error);
        this.$message.error('加载表格数据失败');
      } finally {
        this.tableLoading = false;
      }
    },
    
    // Tab切换
    handleTabChange(key) {
      this.activeKey = key;
    },
    
    // 显示弹窗
    showModal(action, item = null) {
      this.editMode = action;
      if (action === 'add') {
        this.resetForm();
      } else if (action === 'edit' && item) {
        this.form = {
          ...item,
          farm_id: this.farmId,
          breed_item_id: this.itemId,
        };
      }
      this.isModalVisible = true;
    },
    
    // 重置表单
    resetForm() {
      this.form = {
        farm_id: this.farmId,
        height: '',
        shen_chang: '',
        weight: '',
        width: '',
        chest_girth: '',
        recorded_at: '',
        breed_item_id: this.itemId,
      };
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate();
        }
      });
    },
    
    // 提交表单
    handleOk() {
      this.$refs.formRef.validate(async valid => {
        if (valid) {
          this.submitLoading = true;
          try {
            if (this.editMode === 'add') {
              await this.$api.post_biao_xing_records(this.form);
              this.$message.success('添加成功');
            } else {
              await this.$api.putBiaoXingRecord(this.form.id, this.form);
              this.$message.success('更新成功');
            }
            this.isModalVisible = false;
            await this.loadData();
          } catch (error) {
            console.error('提交失败:', error);
            this.$message.error('操作失败');
          } finally {
            this.submitLoading = false;
          }
        }
      });
    },
    
    // 取消弹窗
    handleCancel() {
      this.isModalVisible = false;
    },
    
    // 处理菜单点击
    handleMenuClick(key, record) {
      if (key === 'edit') {
        this.showModal('edit', record);
      } else if (key === 'delete') {
        this.handleDelete(record.id);
      }
    },
    
    // 删除记录
    handleDelete(id) {
      const _self = this;
      this.$confirm({
        title: '确定删除该条表型记录吗？',
        content: '删除后数据将无法恢复',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          return _self.$api.delete_biao_xing_record(id)
            .then(() => {
              _self.$message.success('删除成功');
              _self.loadData();
            })
            .catch(error => {
              console.error('删除失败:', error);
              _self.$message.error('删除失败');
            });
        },
      });
    },
  },
};
</script>

<style scoped>
.biao-xing-section {
  width: 100%;
}

.margin-top-20 {
  margin-top: 20px;
}

.margin-left-10 {
  margin-left: 10px;
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
}
</style>
